module.exports = __webpack_public_path__ + "static/media/pide.8e46a19b.png";